<template>
  <v-switch class="ma-0 pa-0" v-model="data" flat hide-details v-bind="$attrs">
    <template #label>
      <div class="d-flex align-start" style="gap: 0.1rem;">
        {{ label }}
        <SimpleHelperMsg v-if="hint" :msg="hint" v-bind="{ colorIcon }" />
      </div>
    </template>
  </v-switch>
</template>

<script>
export default {
  name: "SimpleSwitch",
  components: { SimpleHelperMsg: () => import("./SimpleHelperMsg.vue") },
  props: {
    value: [String, Boolean, Number],
    label: String,
    hint: String,

    colorIcon: String
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
